<template>
  <div id="slider">
    <div class="slides">
      <transition-group
        name="slide"
        enter-class="slide-in"
        leave-class="slide-out"
        enter-active-class=" slide-in-active"
        leave-active-class=" slide-out-active"
      >
        <div
          v-for="(info) in slideinfoText"
          v-show="info.key == active"
          :key="info.key"
        >
          <p> {{ changePartnerLabelName(marketInfo, info.text, true) }}</p>
        </div>
      </transition-group>
    </div>
    <!-- <span
    class="prev"
    @click="move(-1)"
  >
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </span>
  <span
    class="next"
    @click="move(1)"
  >
    <i class="fa fa-chevron-right" aria-hidden="true"></i>
  </span> -->
    <ul class="dots">
      <li
        v-for="(dot, index) in slideinfoText"
        :key="index"
        :class="{ active: ++index === active }"
        @click="jump(index)"
      />
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CustomCarousel',
  computed: {
    ...mapGetters({
      marketInfo: 'user/marketInfo',
    }),
  },
  props: {
    slideinfoText: Array,
  },
  data() {
    return {
      slides: 3,
      active: 1,
      count: 1,
    };
  },
  methods: {
    move() {
      this.count += 1;
      if (this.count > 3) {
        this.count = 1;
      }
      this.active = this.count;
    },
    jump(index) {
      this.count = index;
      this.active = index;
    },
    // addSlide() {
    //   this.slideinfoText += 1;
    // },
    // removeSlide() {
    //   this.slideinfoText -= 1;
    // },
  },
  mounted() {
    setInterval(() => {
      this.move();
    }, 7000);
  },
};
</script>

<style lang="scss">
// .prev,
// .next {
//   position: absolute;
//   top: 50%;
//   width: 50px;
//   height: 50px;
//   border: 2px solid $primary;
//   color: $primary;
//   border-radius: 50%;
//   margin-top: -25px;
//   margin-left: 25px;
//   cursor: pointer;
//   line-height: 48px;
//   text-align: center;
//   text-indent: -2px;
//   transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);

//   &:hover {
//     background: $primary;
//     color: #fff;
//     transform: scale(1.2);
//   }

//   &:active {
//     transform: translate(0, 3px) scale(1.2);
//   }
// }

.next {
  right: 0;
  margin-left: auto;
  margin-right: 25px;
  text-indent: 2px;
}

.dots {
  position: absolute;
  display: block;
  width: 70%;
  text-align: center;
  bottom: 40px;

  li {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: $primary;
    opacity: 0.2;
    display: inline-block;
    margin: 40px 3px;
    cursor: pointer;
    transition: opacity 0.4s ease-in-out,width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &.active {
     // width: 22px;
      opacity: 1;
    }
  }
}

.slides {
  font-size: 14px;
  display: flex;
   height: 125px;
   color: #7E7E7E;
   font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
//   .animated {
//     transition: all 400ms;
//     position: absolute;
//     transform: translate(-50%, -50%);
//   }

  .slide-in {
    opacity: 0;
    transform: translate(-40%, -50%);
  }

  .slide-in-active {
    transition-delay: 150ms;
  }

  .slide-out {
    opacity: 1;
  }

  .slide-out-active {
    opacity: 0;
    transform: translate(-60%, -50%);
  }
}
</style>
